<template>
  <div class="reform-progress">
    <div class="section-title">
      <!-- <span class="title-icon">⚡</span> -->
      <span class="title-text">产改进行时</span>
    </div>

    <div class="content-wrapper two-col">
      <!-- 左列：KPI + 下方（单指标 + 条形图） -->
      <div class="left-col">
        <!-- 顶部：6个KPI，无边框，仅文字+数字（数字在下） -->
        <div class="kpi-simple">
          <div v-for="(item, index) in kpiData" :key="index" class="kpi-simple-item"
               :style="{ '--card-color': item.color }">
            <div class="kpi-simple-label">{{ item.label }}</div>
            <div class="kpi-simple-value">
              <span class="value">{{ item.value }}</span>
              <span class="unit">{{ item.unit }}</span>
            </div>
          </div>
        </div>
        <!-- 下方：左边单指标（劳模工匠），右边条形图 -->
        <div class="bottom-two-col">
          <div class="single-metric">
            <div class="single-metric-label">劳模工匠</div>
            <div class="single-metric-value">
              <span class="value">{{ lmgjNum }}</span>
              <span class="unit">人</span>
            </div>
          </div>
          <div class="bar-chart">
            <Echart :options="incomeChartOptions" id="IncomeChart" height="100%" width="100%"></Echart>
            <div class="chart-titles">职工收入动态（年平均工资）</div>
          </div>
        </div>
      </div>
      <!-- 右列：满意度仪表盘 -->
      <div class="right-col">
        <div class="gauge-card">
          <div class="gauge-body">
            <Echart :options="satisfactionGaugeOptions" id="SatisfactionGaugeChart" height="100%"
                    width="100%"></Echart>
          </div>
          <div class="chart-title">职工满意度</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mydBg from '../../assets/myd-bg.png'
import {get} from "@/utils/request";

export default {
  name: 'ReformProgress',
  props: {
    cgjxsList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      VUE_APP_API_BASE_URL:"https://dp.houkongfan.cn",
      lmgjNum: 0,//劳模工匠数量
      kpiData: [{
        label: '创新工作室',
        value: '',
        unit: '个',
        color: '#00f5b4'
      },
        {
          label: '活动培训',
          value: '',
          unit: '次',
          color: '#00f5b4'
        },
        {
          label: '职工夜校',
          value: '',
          unit: '次',
          color: '#00f5b4'
        },
        {
          label: '安全巡查',
          value: '',
          unit: '次',
          color: '#ffd820'
        },
        {
          label: '职工讲堂',
          value: '',
          unit: '次',
          color: '#00f5b4'
        },
        {
          label: '技能比武',
          value: '',
          unit: '次',
          color: '#00f5b4'
        },
      ],
      satisfactionValue: 95,
      incomeData: [{
        year: '2019年',
        value: 5.88
      },
        {
          year: '2025年',
          value: 8.13
        }
      ],
      mydBg,
    }
  },
  computed: {
    satisfactionGaugeOptions() {
      return {
        backgroundColor: 'transparent',
        series: [
          // 外圈刻度与分割线
          {
            type: 'gauge',
            startAngle: 200,
            endAngle: -20,
            min: 0,
            max: 100,
            radius: '90%',
            splitNumber: 50,
            axisLine: {
              lineStyle: {
                width: 10,
                color: [
                  [1, 'rgba(0, 217, 255, 0.10)']
                ],
              },
            },
            axisTick: {
              distance: -12,
              splitNumber: 4,
              lineStyle: {
                color: 'rgba(0, 217, 255, 0.6)',
                width: 1,
              },
              length: 6,
            },
            splitLine: {
              distance: -12,
              lineStyle: {
                color: '#00d9ff',
                width: 2,
              },
              length: 12,
            },
            axisLabel: {
              color: '#9ab3c0',
              distance: 12,
              fontSize: 10,
              formatter: (val) => {
                // 只显示 0, 20, 40, 60, 80, 100
                if ([0, 20, 40, 60, 80, 100].includes(val)) {
                  return `${val}%`;
                }
                return '';
              },
            },
            pointer: {
              show: false
            },
            detail: {
              show: false
            },
          },
          // 进度弧

          // 指针与中心文字
          {
            type: 'gauge',
            startAngle: 200,
            endAngle: -20,
            min: 0,
            max: 100,
            radius: '78%',
            axisLine: {
              lineStyle: {
                width: 0
              }
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisLabel: {
              show: false
            },
            anchor: {
              show: true,
              showAbove: true,
              size: 8,
              itemStyle: {
                color: '#00eaff'
              }
            },
            pointer: {
              show: true,
              length: '70%',
              width: 4,
              itemStyle: {
                color: '#00eaff',
                shadowBlur: 6,
                shadowColor: 'rgba(0,234,255,0.7)'
              },
            },
            detail: {
              valueAnimation: true,
              formatter: () => `满意度${this.satisfactionValue}%`,
              color: '#ffc000',
              fontSize: 16,
              fontWeight: 'bold',
              offsetCenter: [0, '25%'],
            },
            data: [{
              value: this.satisfactionValue
            }],
          },
          // 内层装饰弧
          {
            type: 'gauge',
            startAngle: 200,
            endAngle: -20,
            min: 0,
            max: 100,
            radius: '56%',
            axisLine: {
              lineStyle: {
                width: 2,
                color: [
                  [1, 'rgba(0, 217, 255, 0.35)']
                ]
              }
            },
            pointer: {
              show: false
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisLabel: {
              show: false
            },
            detail: {
              show: false
            },
          },
        ],
      }
    },
    incomeChartOptions() {
      return {
        backgroundColor: 'transparent',
        grid: {
          left: '15%',
          right: '10%',
          top: '5%',
          bottom: '15%',
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
          formatter: (params) => {
            const param = params[0]
            return `${param.name}<br/>${param.value} 万元`
          },
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          borderColor: '#00d9ff',
          borderWidth: 1,
          textStyle: {
            color: '#fff',
          },
        },
        xAxis: {
          type: 'value',
          name: '',
          nameTextStyle: {
            color: '#6b7d8f',
            fontSize: 12,
          },
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            color: '#6b7d8f',
            fontSize: 12,
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(0, 217, 255, 0.1)',
              type: 'dashed',
            },
          },
        },
        yAxis: {
          type: 'category',
          data: this.incomeData.map(item => item.year).reverse(),
          axisLine: {
            show: true,
            lineStyle: {
              color: 'rgba(0, 217, 255, 0.3)',
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            color: '#fff',
            fontSize: 14,
          },
        },
        series: [{
          type: 'bar',
          data: [...this.incomeData].reverse().map((item) => ({
            value: item.value,
            itemStyle: {
              color: item.year === '2019年' ? '#9eddfc' : '#1e82ca',
              borderRadius: [0, 4, 4, 0],
            },
          })),
          barWidth: '50%',
          label: {
            show: true,
            position: 'right',
            formatter: '{c} 万元',
            color: '#fff',
            fontSize: 14,
            fontWeight: 'normal',
          },
        },],
      }
    },
  },
  mounted() {
    this.onLoadInfo()
  },
  methods: {
    async onLoadInfo() {
      const url =this.VUE_APP_API_BASE_URL + "/dev-api/system/page1/queryList/model3"
      const result = await get(url)
      // 查询产业类型列表
      this.cgjxsList = result.data.cgjxsList
      if (result.success) {
        if (!this.cgjxsList || this.cgjxsList.length === 0) return;

        const data = this.cgjxsList[0];

        // 映射所有KPI数据
        this.kpiData[0].value = data.cxgzsNum;  // 创新工作室
        this.kpiData[1].value = data.hdpxNum;   // 活动培训
        this.kpiData[2].value = data.zgyxNum;   // 职工夜校
        this.kpiData[3].value = data.aqxcNum;   // 安全巡查
        this.kpiData[4].value = data.zgjtNum;   // 职工讲堂
        this.kpiData[5].value = data.jnbwNum;   // 技能比武

        // 更新劳模工匠数据
        this.lmgjNum = data.lmgjNum;

        // 更新收入数据
        this.incomeData = [
          {
            year: '2019年',
            value: parseFloat(data.srgz19) || 0
          },
          {
            year: '2025年',
            value: parseFloat(data.srgz25) || 0
          }
        ];

        // 更新满意度数据
        this.satisfactionValue = parseFloat(data.zgmyd) || 0;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.reform-progress {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;

  .section-title {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 15px;
    font-size: 18px;
    font-weight: 600;
    color: #fff;
    padding-bottom: 8px;
    border-bottom: 2px solid rgba(0, 217, 255, 0.3);

    .title-icon {
      font-size: 20px;
    }
  }

  .content-wrapper {
    display: flex;
    flex-direction: column;
    gap: 15px;
    flex: 1;
    min-height: 0;
  }

  .two-col {
    display: grid;
    grid-template-columns: 2fr 1fr;
    gap: 16px;
  }

  .left-col {
    display: flex;
    flex-direction: column;
    gap: 30px;
    height: 300px;
    min-width: 0;
  }

  .right-col {
    display: flex;
    flex-direction: column;
    height: 86%;
    min-width: 0;
  }

  // 顶部6项简洁样式（无边框）
  .kpi-simple {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: 16px;

    .kpi-simple-item {
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      .kpi-simple-label {
        color: rgb(243, 229, 245);
        font-weight: normal;
        font-family: 钉钉进步体, Arial, "sans-serif";
        font-size: 22px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        line-height: normal;
        margin: 0px 0px 7px;
        justify-content: flex-start;
        width: 100%;
      }

      .kpi-simple-value {
        margin-top: 6px;
        display: flex;
        align-items: baseline;
        gap: 6px;

        .value {
          font-size: 32px;
          font-weight: 800;
          color: var(--card-color);
          text-shadow: 0 0 10px rgba(0, 217, 255, 0.25);
          line-height: 1;
        }

        .unit {
          font-size: 14px;
          color: #6b7d8f;
        }
      }
    }
  }

  // 下方左右布局：左单指标 + 右条形图
  .bottom-two-col {
    display: grid;
    grid-template-columns: 1fr 4.55fr;
    gap: 16px;

    .single-metric {
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 10px 12px;

      .single-metric-label {
        color: rgb(243, 229, 245);
        font-weight: normal;
        font-family: 钉钉进步体, Arial, "sans-serif";
        font-size: 22px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        line-height: normal;
        margin: 0px 0px 7px;
        justify-content: flex-start;
        width: 100%;
      }

      .single-metric-value {
        margin-top: 8px;
        display: flex;
        align-items: baseline;
        gap: 6px;

        .value {
          font-size: 40px;
          font-weight: 800;
          color: #00ff88;
          line-height: 1;
          text-shadow: 0 0 10px rgba(0, 255, 136, 0.25);
        }

        .unit {
          font-size: 16px;
          color: #6b7d8f;
        }
      }
    }

    .bar-chart {
      background: rgba(0, 217, 255, 0.05);
      border-radius: 6px;
      padding: 8px;
      display: flex;
      flex-direction: column;
      flex: 1;
      min-height: 0;

      :deep(#IncomeChart) {
        flex: 1;
        min-height: 0;
      }

      .chart-title {
        font-size: 13px;
        color: #6b7d8f;
        margin-top: 8px;
        text-align: center;
      }

      .chart-titles {
        font-size: 20px;
        color: #a2cde5;
        margin-top: 8px;
        text-align: center;
      }

    }
  }

  .gauge-card {
    // background: rgba(0, 217, 255, 0.05);
    // border: 1px solid rgba(0, 217, 255, 0.2);
    // border-radius: 6px;
    padding: 12px;
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    position: relative;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;

    .gauge-body {
      flex: 1;
      min-height: 0;
    }

    .chart-title {
      font-size: 13px;
      color: #a2cde5;
      margin-bottom: 28px;
      text-align: center;
      position: absolute;
      bottom: 35px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 10;
      white-space: nowrap;
    }
  }
}
</style>
